import { useCallback, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { Header } from '../components/landing/Header'
import { HeroSection } from '../components/landing/HeroSection'
import { CodeDemoSection } from '../components/landing/CodeDemoSection'
import { SmartFeaturesSection } from '../components/landing/SmartFeaturesSection'
import { PricingPreviewSection } from '../components/landing/PricingPreviewSection'
import { FinalCTASection } from '../components/landing/FinalCTASection'
import { Footer } from '../components/landing/Footer'
import toast from 'react-hot-toast'

export function LandingPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()

  // Scroll to hash section when navigated from another page (e.g. /docs → /#features)
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }, [location.hash])

  const handleSignUpClick = useCallback(() => {
    try {
      navigate('/signup', { state: { from: 'landing', intent: 'signup' } })
    } catch (error) {
      console.error('Navigation error:', error)
      toast.error('Navigation failed. Please try again.')
    }
  }, [navigate])

  const handleDashboardClick = useCallback(() => {
    try {
      if (user) {
        navigate('/dashboard', { state: { from: 'landing' } })
      } else {
        navigate('/login', { state: { from: 'landing', intent: 'signin' } })
      }
    } catch (error) {
      console.error('Navigation error:', error)
      toast.error('Navigation failed. Please try again.')
    }
  }, [navigate, user])

  const handlePricingClick = useCallback(() => {
    try {
      navigate('/pricing', { state: { from: 'landing' } })
    } catch (error) {
      console.error('Navigation error:', error)
      toast.error('Navigation failed. Please try again.')
    }
  }, [navigate])

  return (
    <div className="min-h-screen bg-bg overflow-x-hidden">
      {/* Header */}
      <Header
        isAuthenticated={!!user}
        onDashboardClick={handleDashboardClick}
        onSignUpClick={handleSignUpClick}
      />

      <main>
        {/* Hero Section */}
        <HeroSection
          isAuthenticated={!!user}
          onSignUpClick={handleSignUpClick}
          onDashboardClick={handleDashboardClick}
          onPricingClick={handlePricingClick}
        />

        {/* Code Demo Section */}
        <CodeDemoSection />

        {/* Smart Features Section */}
        <SmartFeaturesSection />

        {/* Pricing Preview Section */}
        <PricingPreviewSection />

        {/* Final CTA Section */}
        <FinalCTASection
          isAuthenticated={!!user}
          onSignUpClick={handleSignUpClick}
          onDashboardClick={handleDashboardClick}
          onPricingClick={handlePricingClick}
        />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}
